export const SAVE_DETAILS_FAILURE = 'SAVE_DETAILS_FAILURE';
export const SAVE_DETAILS_SUCCESS = 'SAVE_DETAILS_SUCCESS';
export const LOAD_CALCULATORS_SUCCESS = 'LOAD_CALCULATORS_SUCCESS';
export const LOAD_CALCULATORS_FAILURE = 'LOAD_CALCULATORS_FAILURE';
export const LOAD_BUDGET_LINE_ITEM_SUCCESS = 'LOAD_BUDGET_LINE_ITEM_SUCCESS';
export const LOAD_BUDGET_LINE_ITEM_FAILURE = 'LOAD_BUDGET_LINE_ITEM_FAILURE';
export const PENDING_BUDGET_LINE_ITEM = 'PENDING_BUDGET_LINE_ITEM';
export const MOVE_TO_BUDGET_ITEM_SUCCESS = 'MOVE_TO_BUDGET_ITEM_SUCCESS';

// Values types
export const SAVE_VALUE_SUCCESS = 'SAVE_VALUE_SUCCESS';
export const SAVE_VALUE_FAILURE = 'SAVE_VALUE_FAILURE';
export const SAVE_VALUES_FAILURE = 'SAVE_VALUES_FAILURE';
export const SAVE_VALUES_SUCCESS = 'SAVE_VALUES_SUCCESS';
export const SAVE_GRID_INDEX_SUCCESS = 'SAVE_GRID_INDEX_SUCCESS';
export const SAVE_GRID_INDEX_FAILURE = 'SAVE_GRID_INDEX_FAILURE';
export const SAVE_SLIDER_INDEX_SUCCESS = 'SAVE_SLIDER_INDEX_SUCCESS';
export const SAVE_SLIDER_INDEX_FAILURE = 'SAVE_SLIDER_INDEX_FAILURE';

// RESET WANTS
export const RESET_CALCULATOR_SUCCESS = 'RESET_CALCULATOR_SUCCESS';


// WEBPACK FOOTER //
// ./src/actions/types.js